<template>
	<div class="page flex-col">
		<!-- <div class="block_15 flex-col">
			<div class="group_17 flex-row">
				<img class="label_5" referrerpolicy="no-referrer" src="@/assets/icon/icon_scan.png" />
				<div class="image-wrapper_5 flex-col">
					<img class="label_6" referrerpolicy="no-referrer" src="@/assets/icon/icon_search.png" />
				</div>
				<img class="label_7" @click="kefu_to" referrerpolicy="no-referrer" src="@/assets/icon/icon_kf2.png" />
				<img class="label_8" referrerpolicy="no-referrer" src="@/assets/icon/icon_message.png" />
			</div>
		</div> -->
		<div class="block_1 flex-col">
			<div class="banner flex-col">
				<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(image, index) in bannerImages" :key="index">
						<img :src="image" class="swipe-image" />
					</van-swipe-item>
				</van-swipe>
			</div>
			<div class="text-wrapper_1 flex-col">
				<div class="video-container">
					<video controls autoplay playsinline muted loop preload="auto" webkit-playsinline x5-playsinline
						x5-video-player-type="h5" x5-video-player-fullscreen="true"
						style="width: 100%; height: 100%; object-fit: cover">
						<source src="video/xuanchuan.mp4" type="video/mp4" />
					</video>
				</div>
			</div>
			<div class="group_13">
				<img src="@/assets/images/home_title1.png" />
			</div>
			<!-- <div class="text-wrapper_2 flex-col">
				<img src="@/assets/images/home_title2.png" />
			</div> -->
			<img class="image_wenjian" referrerpolicy="no-referrer" src="@/assets/images/home_wenjian2.png" />
			<div class="group_14">
				<img src="@/assets/images/home_title3.png" />
			</div>
			<div class="group_15 flex-row justify-between">
				<img src="@/assets/images/home_icon1.png" @click="downloads" />
				<img src="@/assets/images/home_icon2.png" @click="showServicePopup = true" />
				<!-- <img src="@/assets/images/home_icon3.png" @click="inviteNew" /> -->
				<img src="@/assets/images/home_icon3.png" @click="showInvitePopup = true" />
				<img src="@/assets/images/home_icon4.png" @click="authEmail" />
			</div>
			<div class="text-wrapper_4 flex-col">
				<img src="@/assets/images/home_title4.png" />
			</div>
			<div class="block_9 flex-col">
				<img src="@/assets/images/home_bottom.png" />
			</div>
		</div>

		<!-- 在线客服弹窗 -->
		<van-dialog v-model="showServicePopup" title="在线客服" :show-cancel-button="false" confirm-button-text="关闭"
			@confirm="showServicePopup = false">
			<div class="qrcode-container">
				<img :src="serviceQrcode" alt="在线客服二维码" class="qrcode-image">
				<p class="qrcode-tip">扫描二维码联系在线客服</p>
			</div>
		</van-dialog>

		<!-- 邀请好友弹窗 -->
		<van-dialog v-model="showInvitePopup" title="邀请好友" :show-cancel-button="false" confirm-button-text="关闭"
			@confirm="showInvitePopup = false" class="van-popup van-popup--center invite-dialog">
			<div class="invite-content">
				<div class="invite-code-section">
					<div class="invite-code-label">我的邀请码</div>
					<div class="invite-code">{{ inviteData.invitation_code }}</div>
				</div>
				<div class="qrcode-section">
					<div class="invite-qrcode">
						<img :src="inviteData.share_image_url" alt="" />
					</div>
					<p class="qrcode-tip">扫描二维码邀请好友注册</p>
				</div>
				<div class="invite-url-section">
					<div class="invite-url">{{ inviteData.share_link }}</div>
					<van-button type="primary" size="small" class="copy-link-btn" @click="copyLink">
						复制链接
					</van-button>
				</div>
			</div>
		</van-dialog>

		<!-- 公告消息弹窗 -->
		<van-dialog className="noicePop" v-model="showNoicePop" title="公告消息" confirm-button-text="下一页"
			:beforeClose="noicePopBeforeClose">
			<div class="noicePopContent" v-if="noticeList[noticeIndex]">
				<div v-html="noticeList[noticeIndex].content"></div>
			</div>
		</van-dialog>

		<!-- 实名认证弹窗 -->
		<van-popup v-model="showRealPopup" class="real-name-popup" :style="{ width: '90%' }" round position="center">
			<div class="real-name-container">
				<div class="real-name-header">
					<div class="real-name-title">实名认证得补贴</div>
					<div class="real-name-subtitle">
						完成实名认证即可获得<br />五行商会奖励150万和50枚五行币
					</div>
				</div>
				<div class="real-name-actions">
					<van-button class="cancel-button" round type="default" @click="handleCancel">
						取消
					</van-button>
					<van-button class="real-name-button" round type="primary" @click="$router.push('/authEmail')">
						马上认证
					</van-button>
				</div>
			</div>
		</van-popup>

		<!-- 提现弹窗 -->
		<van-popup v-model="showWithdrawPopup" class="withdraw-popup" :style="{ width: '90%' }" round position="center">
			<div class="withdraw-popup-container">
				<!-- 关闭按钮 -->
				<div class="close-btn" @click.stop="showWithdrawPopup = false">
					<van-icon name="cross" color="#999" size="18" />
				</div>
				<!-- 弹窗内容 -->
				<div class="popup-content" @click="goToVerification">
					<img src="@/assets/withdraws/popup1.png" alt="提现提醒" class="withdraw-popup-image" />
				</div>
			</div>
		</van-popup>

		<!-- 税收政策弹窗 -->
		<van-popup v-model="showTaxPopup" class="tax-popup" :style="{ width: '90%' }" round position="center"
			:close-on-click-overlay="false">
			<div class="tax-popup-container">
				<!-- 弹窗内容 -->
				<div class="tax-content">
					<template v-if="is_pay_taxes == 0">
						<!-- 背景图片 -->
						<img src="@/assets/images/tax_popup.png" alt="税收政策" class="tax-bg-image" />
						<!-- 按钮图片 -->
						<div class="tax-button-wrapper" @click="goToOnlinePayment">
							<img src="@/assets/images/tax_button.png" alt="确认" class="tax-button-image" />
						</div>
					</template>
					<template v-else>
						<img src="@/assets/images/tax_popup2.png" alt="税收政策" class="tax-bg-image" />
					</template>
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
	import Vue from "vue";
	import {
		videoPlayer
	} from "vue-video-player";
	import "video.js/dist/video-js.css";
	import {
		WOW
	} from "wowjs";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import VuePlyr from "vue-plyr";
	import "vue-plyr/dist/vue-plyr.css";
	import "swiper/dist/css/swiper.css";
	import Fetch from "../../utils/fetch";
	import Api from "../../interface/index";
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field,
		Circle,
		Switch,
		Button,
		Toast,
		Popup
	} from "vant";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Circle).use(Switch).use(Button).use(Toast).use(Popup);
	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
			swiper,
			videoPlayer,
			swiperSlide,
		},
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				videoSrc: require("@/assets/mp4/00002.mp4"),
				playerOptions: {
					autoplay: true,
					muted: true,
					loop: true,
					sources: [{
						src: require("@/assets/mp4/00002.mp4"),
						type: "video/mp4",
					}, ],
				},
				show_kefu: false,
				msg_show: true,
				loading: false,
				icon: [],
				auto_close: [],
				app_url: "",
				data: {},
				datawudi: {},
				show_img: false,
				show_tz: false,
				number: "",
				sku: [],
				swiperOption: {
					centeredSlides: true,
					slidesPerView: "auto",
					loop: true,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false,
					},
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				},
				wowdata: "",
				checked: true,
				show: false,
				amount: "",
				inviteData: {},
				showInvitePopup: false, // 邀请好友弹窗
				serviceQrcode: null, // 在线客服二维码
				showServicePopup: false, // 在线客服弹窗
				// 轮播图
				bannerImages: [
					require("@/assets/images/home_bnaner1.jpg"),
					require("@/assets/images/home_bnaner2.jpg"),
					require("@/assets/images/home_bnaner3.jpg"),
					require("@/assets/images/home_bnaner4.jpg"),
				],
				noticeList: [],
				noticeIndex: 0,
				showNoicePop: false,
				showRealPopup: false,
				showWithdrawPopup: false, // 提现弹窗显示控制
				is_account_verification: 0,
				is_pay_taxes: 0,
				showTaxPopup: false, // 税收政策弹窗显示控制
			};
		},
		watch: {
			wowdata() {
				this.$nextTick(() => {
					// 在dom渲染完后,再执行动画
					this.$wow.init();
				});
			},
			showNoicePop(newVal, oldVal) {
				if (newVal === false && oldVal === true) {
					// 公告弹窗关闭后，显示税收政策弹窗
					// this.showTaxPopup = true;
					// 公告弹窗关闭后，检查是否需要显示实名认证弹窗
					setTimeout(() => {
						// this.checkAndShowRealNamePopup();
						// 同时检查是否需要显示提现弹窗
						this.checkWithdrawStatus();
					}, 500);
				}
			}
		},
		created() {
			this.$parent.footer("index");
		},
		mounted() {
			// this.$nextTick(() => {

			// this.$refs.videoRef.addEventListener('ended', this.restartVideo());
			// });
			this.$nextTick(() => {
				this.$wow.init();
			});
			this.systemInfo();
			this.getInviteInfo();
			this.start();
			this.starts(); // 看个人信息
			//代理标识设置
			if (this.$router.history.current.query.agent) {
				localStorage.setItem("agent", this.$router.history.current.query.agent);
			}
			console.log();
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			// setTimeout(() => {
			// 	this.checkAndShowRealNamePopup();
			// }, 1000);
		},
		methods: {
			goToOnlinePayment() {
				this.showTaxPopup = false;
				this.$router.push({
					name: 'onlinePayment',
					query: {
						id: 9
					}
				});
			},
			// 检查提现记录
			checkWithdrawStatus() {
				// 如果实名认证弹窗正在显示，则延迟检查提现弹窗
				if (this.showRealPopup) {
					// 实名认证弹窗关闭后再检查提现弹窗
					const checkAfterRealPopup = () => {
						if (!this.showRealPopup) {
							this.performWithdrawCheck();
						} else {
							setTimeout(checkAfterRealPopup, 100);
						}
					};
					setTimeout(checkAfterRealPopup, 100);
				} else {
					this.performWithdrawCheck();
				}
			},
			performWithdrawCheck() {
				if (this.is_account_verification) {
					// 延迟显示，避免与其他弹窗冲突
					// setTimeout(() => {
					console.log('不需要显示提现提醒弹窗', this.is_account_verification)
					// }, 500);
				} else {
					console.log('显示提现提醒弹窗', this.is_account_verification)
					this.showWithdrawPopup = true;
				}
			},
			// 跳转到verification组件
			goToVerification() {
				this.showWithdrawPopup = false;
				this.$router.push({
					name: 'verification',
					params: {
						type: 'failed' // 或者根据实际需求传递其他type
					}
				});
			},
			// 检查并显示实名认证弹窗
			checkAndShowRealNamePopup() {
				if (this.datawudi && this.datawudi.is_auth === 0) {
					this.showRealPopup = true;
				}
			},
			// 处理取消按钮点击
			handleCancel() {
				this.showRealPopup = false;
				this.checkWithdrawStatus();
			},
			// 实名认证按钮点击
			handleRealNameAuth() {
				this.showRealPopup = false;
				this.$router.push('/authEmail');
			},
			noicePopBeforeClose(action, done) {
				if (this.noticeIndex >= this.noticeList.length - 1) {
					done(true)
				} else {
					this.noticeIndex++
					done(false)
				}
			},
			//  restartVideo() {
			//     this.$refs.videoRef.currentTime = 0;
			//     this.$refs.videoRef.play();
			// },
			beforeClose(action, done) {
				if (action === "cancel") {
					done();
					return;
				}
				if (!this.amount || this.amount > parseFloat(this.datawudi.all_money)) {
					this.$toast({
						className: "toastName",
						message: "请输入有效金额",
					});
					done(false);
					return;
				}

				// 提交逻辑
				this.submits()
					.then(() => {
						done();
					})
					.catch(() => {
						done(false);
					});
			},
			submits() {
				return new Promise((resolve) => {
					// console.log('提交金额:', this.amount, '备注:', this.remark);
					// this.$toast.success('提交成功');
					// this.show = false;
					// resolve();
					Fetch("/user/fundsConversion", {
						money: this.amount,
					}).then((res) => {
						this.show = false;
						this.amount = "";
						resolve(res.data);
						this.$toast({
							className: "toastName",
							message: res.info["zh_cn"] ? res.info["zh_cn"] : res.info,
						});
						setTimeout(() => {
							this.$router.replace("/moneybag");
						}, 2000);
					});
				});
			},
			// withdraw() {
			// 	if (this.datawudi.inviteCount == 0) {
			// 		this.$toast({
			// 			className: "toastName",
			// 			message: `还需要邀请2位好友`,
			// 		});
			// 		return;
			// 	} else if (this.datawudi.inviteCount == 1) {
			// 		this.$toast({
			// 			className: "toastName",
			// 			message: "还需要邀请1位好友",
			// 		});
			// 		return;
			// 	}
			// 	Fetch('/user/fundsConversion').then((res) => {
			// 		this.$toast({
			// 			className: "toastName",
			// 			message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
			// 		});
			// 	})
			// 	this.show = true;
			// },
			// goToBaidu() {
			// 	window.open("https://www.cdb.com.cn/gykh/khjj/", "_blank");
			// 	window.location.href = 'https://www.cdb.com.cn/gykh/khjj/';
			// },
			starts() {
				Fetch("/user/info").then((r) => {
					this.datawudi = r.data;
					this.is_account_verification = r.data.is_account_verification;
					this.is_pay_taxes = r.data.is_pay_taxes;
				}).catch(e => {
					console.error('Fetch /user/info failed', e);
				});
			},
			systemInfo() {
				Fetch('/user/system_info').then((r) => {
					this.serviceQrcode = r.data.service_img;
				});
			},
			getInviteInfo() {
				Fetch("/user/myTeam").then((r) => {
					this.inviteData = r.data;
				});
			},
			inviteNew() {
				this.$router.push("/inviteNew");
			},
			authEmail() {
				if (this.datawudi.is_auth == 1) {
					this.$toast({
						className: "toastName",
						message: "已实名\n修改实名信息请联系客服",
					});
				} else {
					this.$router.push("/authEmail");
				}
			},
			downloads() {
				this.$router.push("/downloadApp");
			},
			hideDown() {
				this.show_img = false;
				this.$store.commit("setShowAdvert", false);
			},
			goD() {
				window.location.href = this.app_url;
			},
			start() {
				Fetch("/index/int").then((r) => {
					//打包web请注释掉版本更新这段代码
					//-----------------------------------------

					let u = navigator.userAgent;
					let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
					let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
					if (isAndroid) {
						// alert("我是安卓");
						this.app_url = r.data.version.android_app_down_url;
					}
					if (isIOS) {
						// alert("我是苹果");
						this.app_url = r.data.version.ios_app_down_url;
					}

					// if(window.plus){
					// let appVersion1 = plus.runtime.version;
					// let appVersion2 = r.data.version.app_version;
					// //版本号不同则更新APP
					// if(parseInt(appVersion1.split(".").join(""))<parseInt(appVersion2.split(".").join(""))){
					// 	this.$dialog.alert({
					// 	  title: 'APP更新',
					// 	  message: r.data.version.app_instructions,
					// 	}).then(() => {
					// 		let u = navigator.userAgent;
					// 		let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
					// 		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
					// 		if (isAndroid) {
					// 		 // alert("我是安卓");
					// 			window.location.href = r.data.version.android_app_down_url;
					// 		}
					// 		if (isIOS) {
					// 		 // alert("我是苹果");
					// 		 window.location.href = r.data.version.ios_app_down_url;
					// 		}
					// 	});
					// }
					// }
					//-----------------------------------------
					this.data = r.data;
					this.loading = true;
					console.log(this.data);
					this.noticeList = r.data.popup;
					if (this.noticeList && this.noticeList.length > 0) {
						this.showNoicePop = true;
						this.noticeIndex = 0;
					}
				});
				Fetch("/index/item_auto").then((r) => {
					for (var i = 0; i < r.data.ids.length; i++) {
						this.auto_close.push(parseInt(r.data.ids[i]));
					}
				});
			},
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			changeAuto(e) {
				Fetch("/index/item_auto_c", {
						pid: this.sku.id,
						tz_auto: this.checked ? 1 : 0,
					})
					.then((r) => {})
					.catch((err) => {
						this.psd_val = "";
					});
			},
			buy(item) {
				this.sku = item;
				if (this.auto_close.indexOf(item.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.show_tz = true;
			},
			// openTips() {
			// 	this.$toast({
			// 		className: "toastName",
			// 		message: '暂未开放',
			// 	});
			// 	return;
			// },
			confirm() {
				// if(!this.number){
				// 	this.$toast(this.$t('item.inputAmount'));
				// 	return false;
				// }

				Fetch("/index/item_apply", {
						id: this.sku.id,
						tz_auto: this.checked ? 1 : 0,
						money: this.number,
					})
					.then((r) => {
						this.$router.push("/order");
					})
					.catch((err) => {
						this.psd_val = "";
					});
			},
			getBindWx() {
				if (this.datawudi.wx_switch != 1) {
					this.$toast({
						className: "toastName",
						message: "该功能暂未开放",
					});
				} else if (
					this.datawudi.wx_switch == 1 &&
					this.datawudi.is_open_wx != 1
				) {
					this.getAccount(2);
				} else {
					this.$router.push("/account");
				}
			},
			getBindZfb() {
				if (this.datawudi.zfb_switch != 1) {
					this.$toast({
						className: "toastName",
						message: "该功能暂未开放",
					});
				} else if (
					this.datawudi.zfb_switch == 1 &&
					this.datawudi.is_open_zfb != 1
				) {
					this.getAccount(3);
				} else {
					this.$router.push("/account");
				}
			},
			getAccount(type) {
				this.$router.push({
					path: "/payment",
					query: {
						type: type,
					},
				});
			},
			copyLink() {
				navigator.clipboard.writeText(this.inviteData.share_link).then(() => {
					Toast.success('复制成功');;
				});
			}
		},
	};
</script>
<style src="@/assets/styles/common.css" />
<style lang="less" scoped>
	.page {
		position: relative;
		width: 10rem;
		overflow: hidden;

		.block_15 {
			background-color: rgba(255, 255, 255, 1);
			height: 1.7rem;
			border: 1px solid rgba(226, 226, 226, 1);
			width: 10rem;
			position: fixed;
			left: 0;
			top: 0;
			z-index: 1;

			.group_17 {
				width: 9.054rem;
				height: 0.96rem;
				margin: 0.4rem 0 0.32rem 0.48rem;

				.label_5 {
					width: 0.52rem;
					height: 0.467rem;
					margin-top: 0.24rem;
				}

				.image-wrapper_5 {
					background-color: rgba(247, 247, 247, 1);
					border-radius: 10px;
					height: 0.96rem;
					margin-left: 0.387rem;
					width: 6.214rem;

					.label_6 {}
				}

				.label_7 {
					width: 0.494rem;
					height: 0.494rem;
					margin: 0.227rem 0 0 0.4rem;
				}

				.label_8 {
					width: 0.52rem;
					height: 0.494rem;
					margin: 0.227rem 0 0 0.52rem;
				}
			}
		}

		.block_1 {
			position: relative;
			width: 10rem;
			background: url(~@/assets/index_bg.png) 100% no-repeat;
			background-size: 10rem 100%;
			// padding-top: 1.7rem;
			padding-bottom: 60px;
			background-position: top center;
			/* 添加以下属性防止页面滚动问题 */
			-webkit-overflow-scrolling: touch;
			overflow: hidden;

			.banner {
				margin: 0.45rem 0.47rem;
				border-radius: 0.1rem;
				overflow: hidden;
				width: 9.07rem;
				height: 4.61rem;
				background: #ffffff;
				border: 0px solid #e2e2e2;

				.my-swipe {
					width: 100%;
					height: 100%;
				}

				img {
					width: 100%;
					height: 100%;
				}
			}

			.text-wrapper_1 {
				width: 9.07rem;
				margin: 0 0.47rem;
				background: linear-gradient(94deg, #ffffff, #ff6644);
				box-shadow: 0.04rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.35);
				border-radius: 0.13rem;
				/* 添加以下属性确保正确布局 */
				position: relative;
				overflow: hidden;
				/* 固定高度 */
				height: 5rem;

				.video-container {
					width: 100%;
					height: 100%;
					position: relative;
					/* 防止视频在移动端全屏播放时出现异常 */
					transform: translateZ(0);
					backface-visibility: hidden;
					perspective: 1000;

					video {
						/* 移除内联样式中的固定尺寸 */
						width: 100%;
						height: 100%;
						display: block;
						object-fit: cover;
						/* 添加以下属性解决移动端问题 */
						transform: translateZ(0);
						backface-visibility: hidden;
						-webkit-backface-visibility: hidden;
						/* 防止视频在iOS上全屏 */
						-webkit-touch-callout: none;
						-webkit-user-select: none;
						-khtml-user-select: none;
						-moz-user-select: none;
						-ms-user-select: none;
						user-select: none;
					}
				}
			}

			.group_13 {
				padding: 0.36rem 0 0.36rem 0;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 3.56rem;
					height: 0.427rem;
				}
			}

			.text-wrapper_2 {
				// height: 1.427rem;
				// width: 9.08rem;
				margin: 0 0 0 0.28rem;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					// width: 100%;
					// height: 100%;
					height: 1.6rem;
					width: 9.3rem;
					margin-top: -0.1rem;
					margin-left: -0.25rem;
				}
			}

			.image_wenjian {
				margin: 0.18rem auto 0 auto;
				width: 9.07rem;
			}

			.group_14 {
				padding: 0.57rem 0 0 0;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 2.56rem;
					height: 0.4rem;
				}
			}

			.group_15 {
				width: 10rem;
				margin: 0.8rem 0 0.63rem 0;
				padding: 0 0.47rem;
				display: flex;
				align-items: center;
				justify-content: space-around;

				img {
					width: 1.65rem;
				}
			}

			.text-wrapper_4 {
				// height: 1.427rem;
				// width: 9.08rem;
				margin: 0 0 0 0;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					// width: 100%;
					// height: 100%;
					height: 1.6rem;
					width: 9rem;
				}
			}

			.block_9 {
				// height: 1.427rem;
				// width: 9.08rem;
				margin: 0.4rem 0 0 0;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					// width: 100%;
					// height: 100%;
					height: 2.4rem;
					width: 10rem;
				}
			}

			.text_11 {
				width: 1.16rem;
				height: 0.28rem;
				overflow-wrap: break-word;
				color: rgba(153, 153, 153, 1);
				font-size: 0.293rem;
				font-family: SourceHanSansCN-Regular;
				font-weight: normal;
				text-align: center;
				white-space: nowrap;
				line-height: 0.294rem;
				margin: 0.28rem 0 0.76rem 4.12rem;
			}
		}

		.qrcode-container {
			padding: 4.26667vw;
			text-align: center;

			.qrcode-image {
				width: 53.33333vw;
				height: auto;
				margin-bottom: 4.26667vw;
			}

			.qrcode-tip {
				font-size: 3.73333vw;
				color: #666;
				margin: 0;
			}
		}

		.invite-dialog {
			.invite-content {
				padding: 5.33333vw;
				text-align: center;

				.invite-code-section {
					margin-bottom: 5.33333vw;

					.invite-code-label {
						font-size: 3.73333vw;
						color: #666;
						margin-bottom: 2.13333vw;
					}

					.invite-code {
						font-size: 8.53333vw;
						font-weight: 700;
						color: #e53935;
						letter-spacing: .8vw;
					}
				}

				.qrcode-section {
					margin-bottom: 5.33333vw;

					.invite-qrcode {
						width: 200px;
						height: 200px;
						margin: 0 auto 3.2vw;
						border: 1px solid #eee;
						border-radius: 2.13333vw;

						img {
							width: 200px;
							height: 200px;
						}
					}

					.qrcode-tip {
						font-size: 3.73333vw;
						color: #666;
						margin: 0;
					}
				}

				.invite-url-section {
					.invite-url {
						font-size: 3.2vw;
						color: #999;
						word-break: break-all;
						margin-bottom: 3.2vw;
						padding: 2.13333vw;
						background: #f5f5f5;
						border-radius: 1.06667vw;
					}

					.copy-link-btn {
						width: 100%;
						background: #e53935;
						border-color: #e53935;
					}
				}
			}
		}
	}

	.noicePop {
		width: 9rem;

		/deep/.van-dialog__header {
			padding-top: .3rem !important;
			padding-bottom: .3rem !important;
			background-color: #e53935;
			color: #fff;
			font-size: 16px;
		}

		.noicePopContent {
			padding: 12px 12px;
			max-height: 14rem;
			overflow-y: auto;
		}
	}

	.real-name-container {
		padding: 6.4vw 5.33333vw;
		text-align: center;

		.real-name-header {
			margin-bottom: 5.33333vw;

			.real-name-title {
				font-size: 5.33333vw;
				font-weight: 600;
				color: #e53935;
				margin-bottom: 3.2vw;
				position: relative;
				display: inline-block;
			}

			.real-name-title[data-v-be1f2bc4]:after {
				content: "";
				position: absolute;
				bottom: -1.06667vw;
				left: 50%;
				transform: translateX(-50%);
				width: 10.66667vw;
				height: .53333vw;
				background-color: #e53935;
				border-radius: 1px;
			}

			.real-name-subtitle {
				font-size: 4vw;
				color: #616161;
				line-height: 1.5;
			}
		}

		.real-name-actions {
			display: flex;
			gap: 3.2vw;

			.cancel-button {
				flex: 1;
				height: 11.73333vw;
				font-size: 4.26667vw;
				font-weight: 500;
				background: #fff;
				color: #616161;
				border-color: #ddd;
			}

			.real-name-button {
				flex: 1;
				height: 11.73333vw;
				font-size: 4.26667vw;
				font-weight: 500;
				background: #e53935;
				border-color: #e53935;
				box-shadow: 0 1.06667vw 3.2vw rgba(229, 57, 53, .2);
			}
		}
	}

	/* 提现弹窗样式 */
	.withdraw-popup {
		border-radius: 10px;
		overflow: visible;
		/* 改为visible让关闭按钮可以显示在弹窗外 */

		.withdraw-popup-container {
			position: relative;

			.close-btn {
				position: absolute;
				top: -10px;
				right: -10px;
				width: 30px;
				height: 30px;
				background: #fff;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
				z-index: 100;
				cursor: pointer;

				&:active {
					background: #f5f5f5;
				}
			}

			.popup-content {
				width: 100%;

				.withdraw-popup-image {
					width: 100%;
					height: auto;
					display: block;
					border-radius: 10px;
				}
			}
		}
	}

	/* 税收政策弹窗样式 */
	.tax-popup {
		border-radius: 15px;
		overflow: visible;
		background-color: transparent;

		.tax-popup-container {
			position: relative;

			.close-btn {
				position: absolute;
				top: -10px;
				right: -10px;
				width: 30px;
				height: 30px;
				background: #fff;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
				z-index: 100;
				cursor: pointer;

				&:active {
					background: #f5f5f5;
				}
			}

			.tax-content {
				width: 100%;
				position: relative;

				.tax-bg-image {
					width: 100%;
					height: auto;
					display: block;
					border-radius: 10px;
				}

				.tax-button-wrapper {
					position: absolute;
					bottom: 5%;
					left: 50%;
					transform: translateX(-50%);
					width: 50%;
					cursor: pointer;
					z-index: 10;

					&:active {
						opacity: 0.8;
					}

					.tax-button-image {
						width: 100%;
						height: auto;
						display: block;
					}
				}
			}
		}
	}
</style>